<!-- 车辆管理 -->
<template>
    <div>
        <div class="searchFlex">
            <el-form size="mini" ref="searchform" :model="searchform" label-width="100px" :inline="true" class="demo-form-inline">
                <el-form-item label="车辆信息" style="margin-bottom: 0px !important">
                    <el-input v-model="searchform.info" clearable placeholder="请输入车牌号/司机/电话"></el-input>
                </el-form-item>
                <el-form-item label="" style="margin-bottom: 0px !important">
                    <div class="toolbar">
                        <el-button type="primary" size="mini" @click="getListBy">搜索</el-button>
                        <el-button size="mini" @click="resetSearch">重置</el-button>
                        <el-button type="success" size="mini" @click="addCar">新增</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div style="margin-right:10px;">
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="height: calc(100vh - 171px);">
            <vxe-table height="100%" :data="carList" ref="vehicleTable" id="vehicleTable" size="mini" border stripe
                :column-config="{ resizable: true }" :custom-config="customConfig" :row-config="{ isCurrent: true }"
                highlight-current-row>
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column field="carNo" title="车牌号" min-width="140"></vxe-column>
                <vxe-column field="driver" title="司机" min-width="120"></vxe-column>
                <vxe-column field="driverPhone" title="司机电话" min-width="140"></vxe-column>
                <vxe-column title="操作" width="200" align="center" fixed="right">
                    <template #default="{ row }">
                        <vxe-button mode="text" status="primary" icon="vxe-icon-edit" size="mini"
                            @click="editRow(row)">编辑</vxe-button>
                        <vxe-button mode="text" status="danger" icon="vxe-icon-delete" size="mini"
                            @click="deleteRow(row)">删除</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <!-- 新增车辆弹出框 -->
        <el-dialog title="新增车辆" width="30%" :visible.sync="addCarVisible" :before-close="addCarClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="addCarForm" :model="addCarForm" label-width="90px" size="mini" :rules="rules">
                <el-form-item label="车牌号" prop="carNo">
                    <el-input v-model="addCarForm.carNo" placeholder="请输入车牌号"></el-input>
                </el-form-item>
                <el-form-item label="司机" prop="driver">
                    <el-input v-model="addCarForm.driver" placeholder="请输入司机姓名"></el-input>
                </el-form-item>
                <el-form-item label="司机电话" prop="driverPhone">
                    <el-input v-model="addCarForm.driverPhone" placeholder="请输入司机电话"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="addCarClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveAddCar('addCarForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑车辆弹出框 -->
        <el-dialog title="编辑车辆" width="30%" :visible.sync="editCarVisible" :before-close="editCarClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="editCarForm" :model="editCarForm" label-width="90px" size="mini" :rules="rules">
                <el-form-item label="车牌号" prop="carNo">
                    <el-input v-model="editCarForm.carNo" placeholder="请输入车牌号"></el-input>
                </el-form-item>
                <el-form-item label="司机" prop="driver">
                    <el-input v-model="editCarForm.driver" placeholder="请输入司机姓名"></el-input>
                </el-form-item>
                <el-form-item label="司机电话" prop="driverPhone">
                    <el-input v-model="editCarForm.driverPhone" placeholder="请输入司机电话"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="editCarClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveEditCar('editCarForm')">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'vehicleManagement',
    mixins: [userProfile],
    data() {
        return {
            carList: [], // 车辆列表
            searchform: {
                info: '', // 车牌号/司机/电话等查询信息
            }, // 搜索条件
            addCarVisible: false, // 新增车辆弹窗是否显示
            addCarForm: {
                carNo: '',
                driver: '',
                driverPhone: '',
            }, // 新增车辆数据
            editCarVisible: false, // 编辑车辆弹窗是否显示
            editCarForm: {
                id: '',
                carNo: '',
                driver: '',
                driverPhone: '',
            }, // 编辑车辆数据
            rules: {
                carNo: [
                    { required: true, message: '请输入车牌号', trigger: 'blur' },
                ],
                driver: [
                    { required: true, message: '请输入司机姓名', trigger: 'blur' },
                ],
                // driverPhone: [
                //     { required: true, message: '请输入司机电话', trigger: 'blur' },
                // ],
            },
        }
    },
    //组件创建
    created() {
        this.getList()
    },
    methods: {
        // 点击搜索查询
        getListBy() {
            this.getList()
        },
        // 重置搜索条件
        resetSearch() {
            this.searchform.info = ''
            this.getList()
        },
        // 查询车辆列表
        getList() {
            this.$api.wmsGetCarInfo(this.searchform.info || '').then(res => {
                this.carList = res || []
            })
        },
        // 打开新增弹窗
        addCar() {
            this.addCarVisible = true
        },
        // 关闭新增弹窗
        addCarClose() {
            this.addCarVisible = false
            this.$nextTick(() => {
                this.$refs.addCarForm.resetFields();
            })
            this.addCarForm = {
                carNo: '',
                driver: '',
                driverPhone: '',
            }
        },
        // 新增前去掉前后空格（中间的不动）
        trimFormFields(form) {
            form.carNo = (form.carNo || '').trim()
            form.driver = (form.driver || '').trim()
            form.driverPhone = (form.driverPhone || '').trim()
        },
        // 新增车辆
        saveAddCar(formName) {
            this.trimFormFields(this.addCarForm)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        carNo: this.addCarForm.carNo,
                        driver: this.addCarForm.driver,
                        driverPhone: this.addCarForm.driverPhone,
                    }
                    this.$api.wmsInsCar( params ).then(res => {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.addCarClose()
                        this.getList()
                    })
                }
            })
        },
        // 打开编辑弹窗，带出当前行数据
        editRow(row) {
            this.editCarForm = {
                id: row.id,
                carNo: row.carNo,
                driver: row.driver,
                driverPhone: row.driverPhone,
            }
            this.trimFormFields(this.editCarForm)
            this.editCarVisible = true
        },
        // 关闭编辑弹窗
        editCarClose() {
            this.editCarVisible = false
            this.$nextTick(() => {
                this.$refs.editCarForm.resetFields();
            })
            this.editCarForm = {
                id: '',
                carNo: '',
                driver: '',
                driverPhone: '',
            }
        },
        // 保存编辑（id等信息一起带过去）
        saveEditCar(formName) {
            this.trimFormFields(this.editCarForm)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        id: this.editCarForm.id,
                        carNo: this.editCarForm.carNo,
                        driver: this.editCarForm.driver,
                        driverPhone: this.editCarForm.driverPhone,
                    }
                    this.$api.wmsUpdateCarInfo( params ).then(res => {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.editCarClose()
                        this.getList()
                    })
                }
            })
        },
        // 删除车辆
        deleteRow(row) {
            this.$confirm('是否确定删除此车牌信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsRemoveCarById(row.id).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    this.getList()
                })
            }).catch(() => {
            });
        },
    }
}
</script>
<style lang="css">
.searchFlex{
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items:center;
}
</style>
